import { TBookingContext } from '@providers/booking/types'
import { Types } from 'service-api'
import cloneDeep from 'lodash.clonedeep'

export const firstSelectedDate = (bookingCtx: TBookingContext) => {
  if (bookingCtx.serviceTypeName === 'daycare') {
    if (!bookingCtx.cart.groups[0].daycareSelected) {
      return new Date()
    }
    const _cloned = cloneDeep(bookingCtx.cart.groups[0].daycareSelected!)
    return _cloned.sort(({ id: idA }, { id: idB }) => idA - idB)?.[0].date
  } else {
    return bookingCtx.startDate!
  }
}

export const getOfferServiceInterval = (stConfig?: Types.LocationBookingConfClientDto, defaultInterval = 30) => {
  return stConfig?.arrivalTimeInterval || defaultInterval
}
